// @ts-nocheck
import './styles/index.less'
import './index.css'

import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import { ConfigProvider, setDefaultConfig } from 'antd-mobile'
import router from '@/router'
import { store } from '@/stores/store'
import i18n, { getAntLangFile, getI18nLang } from '@/utils/i18n'
import { utils, lang, storageUtil } from '@/utils'
import { Suspense } from 'react'
import { Skeleton } from 'antd-mobile'
import UserProvider from '@/hooks/userContext'
import SafeArea from '@/components/SafeArea'
import ErrorBoundary from '@/components/ErrorBoundary'
const NODE_ENV = import.meta.env.MODE

const { setLocalStorage } = storageUtil
const { setUidToken, getUrlParameters } = utils
const { getlang } = lang

// 缓存token、uid、language
;(async () => {
  // 仅在 development 和 testing 环境下加载 vconsole
  if (['development', 'testing'].includes(NODE_ENV)) {
    const VConsoleModule = await import('vconsole')
    const VConsole = (VConsoleModule as any).default || VConsoleModule
    // @ts-ignore
    const vConsole = new VConsole()
    console.log('vConsole', vConsole)
  }

  const urlQuery: { [key: string]: string } = getUrlParameters(window.location.href) || {}
  await setUidToken(urlQuery)
  const currentLanguage = await getlang(urlQuery.language)
  setLocalStorage('language', currentLanguage)
  // @ts-ignore
  window.language = currentLanguage

  const i18nLang = getI18nLang()
  i18n.changeLanguage(i18nLang)
  console.log('i18nLang', i18nLang)
  console.log('App 设置', currentLanguage)
  const locale = getAntLangFile()

  setDefaultConfig({
    locale,
  })
})().then(() => {
  createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
      <ConfigProvider>
        <ErrorBoundary>
          <Suspense
            fallback={
              <div style={{ padding: '10px' }}>
                <SafeArea position="top" />
                <Skeleton.Title animated />
                <Skeleton.Paragraph lineCount={5} animated />
              </div>
            }
          >
            <UserProvider>
              <RouterProvider router={router} />
            </UserProvider>
          </Suspense>
        </ErrorBoundary>
      </ConfigProvider>
    </Provider>,
  )
})
